import * as yup from 'yup';
import type { Language } from '@future-harry/nxt-vue-library';
import { useI18n } from 'vue-i18n';

export function buildLanguageFields(languages: Language[] | undefined, options?: { max?: number }): Record<string, yup.StringSchema> {
   const { t } = useI18n();

   const languageFields: Record<string, yup.StringSchema> = {};

   const langs = languages ?? [];
   const max = options?.max;

   langs.forEach((language) => {
      let schema = yup.string().trim().min(1, t('live-editor.content-blocks.errors.required'));

      if (max) {
         schema = schema.max(max, t('live-editor.content-blocks.errors.max-length', { max }));
      }

      schema = schema.required(t('live-editor.content-blocks.errors.required'));

      languageFields[language.iso_639_1.toLowerCase()] = schema;
   });

   return languageFields;
}

export default buildLanguageFields;
